import React from "react";
import ReactDOM from "react-dom/client";
import "index.css";
import App from "App";
import AppErrorBoundary from "components/AppErrorBoundary";
import { installRuntimeMonitoring } from "lib/runtimeMonitoring";
import { install as installReferralCapture } from "lib/referralCapture";

installRuntimeMonitoring();
installReferralCapture();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("React root element is missing.");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
